import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import pt from "./locales/pt.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import uk from "./locales/uk.json";
import zh from "./locales/zh.json";
import af from "./locales/af.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      nl: { translation: nl },
      uk: { translation: uk },
      zh: { translation: zh },
      af: { translation: af },
    },
    fallbackLng: "pt",
    supportedLngs: ["pt", "en", "fr", "es", "de", "nl", "uk", "zh", "af"],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "pp_lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang="..."> in sync with active language for screen readers
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

export const SUPPORTED_LANGS = [
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "de", label: "Deutsch" },
  { code: "nl", label: "Nederlands" },
  { code: "uk", label: "Українська" },
  { code: "zh", label: "中文" },
  { code: "af", label: "Afrikaans" },
] as const;

export default i18n;
